var map = {
	"./cash-icon-home-mobile.webp": 1671,
	"./cashout-icon-home-mobile.webp": 1672,
	"./transfer-icon-home-mobile.webp": 1673,
	"./vip-icon-home-mobile.webp": 1674,
	"./wallet-icon-home-mobile.webp": 1675
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 461;